<template>
  <div>
    <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商解冻审批'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>基本信息</h1>
                </div>
                <div class="h-pieceCon2" style="padding:0">
                  <div class="h-formLine">
                    <div class="tanBox">
                      <el-table
                          :data="tableDatahi"
                          border
                          max-height="420"
                          style="width: 94%; margin:0 auto;">
                        <el-table-column
                            type="index"
                            width="45"
                            label="#">
                        </el-table-column>
                        <el-table-column
                            prop="usercode"
                            label="经销商编码"
                            width="120"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="username"
                            label="经销商名称"
                            width="200"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="fieldLq"
                            label="领域"
                            :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            <div style="text-align: left;">{{scope.row.fieldLq}}</div>
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="area"
                            label="区域"
                            :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            <div style="text-align: left;">
                              {{scope.row.area|dictname('YlSalesArea_chanpin')}}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="lq"
                            label="修改链群"
                            :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            <div style="text-align: left;">{{scope.row.lq}}</div>
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="frozenStatus"
                            label="修改前内容"
                            :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            <div style="text-align: left;">{{scope.row.frozenStatus}}</div>
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="frozenStatusNew"
                            label="修改后内容"
                            :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            <div style="text-align: left;">{{scope.row.frozenStatusNew}}</div>
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="ldate"
                            label="操作时间"
                            value-format="yyyy-MM-dd"
                            width="160"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                      <h1>附件</h1>
                    </div>
                    <div label="解冻附件" class="h-elformWrap-2" style="margin-left:0.5rem;">
                      <brupload
                          :refid="refid"
                          reftype="代理商修改-解冻附件"
                          :uploadflag="false"
                          delflag
                          :tpFlag="true"
                          :showtime="false"
                      >
                      </brupload>
                    </div>
                    </div>
                    <div class="bannerBox2">
                      <div class="h-row h-mrt1">
                        <div class="h-rowIn">
                          <div class="h-rowBox">
                            <div class="h-rowCon">
                              <div class="h-pieceIn2">
                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                  <h1>审核信息</h1>
                                </div>
                                <div class="h-pieceCon2 ">
                                  <div class="h-formLine weekplandetail11" style="position: relative;">
                                    <el-form :inline="true" :model="freezeData">
                                      <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                    style="width: 100%!important;">
                                        <el-input
                                            v-model="freezeData.auditMind2"
                                            placeholder="请输入"></el-input>
                                      </el-form-item>
                                    </el-form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div style="text-align: center;margin-top: 0.3rem">
                      <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回 </el-button>

                      <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)" v-if="!daquflag">驳回</el-button>
                      <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)" v-if="!daquflag">通过</el-button>

                      <el-button class="h-btn h-bBtn h-bgred" @click="daquPass(2)" v-if="daquflag">大区驳回</el-button>
                      <el-button class="h-btn h-bBtn h-bggreen" @click="daquPass(1)" v-if="daquflag">大区通过</el-button>

                      <el-button class="h-btn h-bBtn" @click="viewpress">
                        审批跟踪
                      </el-button>
                    </div>
                    <viewhistory :visible.sync="showhistory" v-if="showhistory"
                                 :id="instid"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import agentCopyService from "../../../api/loud/agent/agentCopyService";
import ss from "../../../api/SystemService";
export default {
  data(){
    return {
      freezeData:[],
      tableDatahi:[],
      refid:null,
      q:{
      },
      taskid:null,
      instid:null,
      showhistory:false,
      daquflag:false,
    }
  },
  filters: {
  },
  methods: {
    handleFilter(){
      this.querypage();
    },
    thawOperate(){
      let query = {
            instid:this.$route.query.instid,
          }
        agentCopyService.getThawLq(query).then(res => {
        console.log("res",res)
          this.freezeData.usercode =  res.msg.usercode;
          this.freezeData.username =  res.msg.username;
          this.freezeData.isZhidan =  res.msg.isZhidan;
          this.tableDatahi = res.msg.lqList
          this.getLqFile();
      })
    },
    getLqFile(){
      let query = {
        usercode:this.freezeData.usercode
      }
      agentCopyService.getLqFile(query).then(res => {
        console.log("res",res);
        this.refid = res.msg.refid;
      })
    },
    choseSelected(){
    },
    pass(aaa){
      let query = {
        taskid:this.$route.query.taskid,
        aaa:aaa,
        auditMind2:this.freezeData.auditMind2,
        usercode: this.freezeData.usercode,
        username:this.freezeData.username,
        isZhidan:this.freezeData.isZhidan,
        instid:this.$route.query.instid,
        ywid:this.$route.query.ywid,
      }
      agentCopyService.agentLqPass(query).then(res => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },
    daquPass(aaa){
      let query = {
        taskid:this.$route.query.taskid,
        aaa:aaa,
        auditMind2:this.freezeData.auditMind2,
        usercode: this.freezeData.usercode,
        username:this.freezeData.username,
        instid:this.$route.query.instid,
        validityPeriodDate:this.freezeData.validityPeriodDate,
        ywid:this.$route.query.ywid,
      }
      agentCopyService.agentLqPass(query).then(res => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },

    viewpress() {
      this.showhistory = true;
    },
    goBack() {
      this.$router.push({
        path: '/agent/agentCopy'
      })
    },

  },
  created(){
    this.thawOperate();
    this.taskid =  this.$route.query.taskid;
    this.instid =  this.$route.query.instid


    if(null != this.$route.query.taskid) {
      ss.taskservice.getTaskByTaskid(this.$route.query.taskid).then(result => {
        console.log("resultresultresult", result.name);
        //判断大区经理审批节点控制审批按钮
        if (result.name == '大区经理审批' || result.name == '省区经理审批') {
          this.daquflag = true;
        }else {
          this.daquflag = false;
        }
      })
    }


  },
  computed: {
    UserCode:function () {
      return this.usercode;
    },
    //订单类型
    dingdLeix:function () {
      return this.ddlx
    },
    //项目编码
    XmCode:function () {
      return this.xmcode
    },
    //    国家
    countryCode:function () {
      return this.country
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
    },
    usercode:{
      type:String,
    },
    //订单类型
    ddlx:{
      type:String,
    },
    oneflag:{
      type:Boolean,
    },
    xmcode:{
      type:String,
    },
    currencyCode:{
      type:String,
    },
    customerChannelCode:{
      type:String,
    },
    country:{
      type:String,
    }
  }
}
</script>

<style>
.xuanzewuliao .el-dialog__header{
  padding-top: 20px;
  padding-left: 20px;
}
.xuanzewuliao .el-dialog__body{
  padding: 20px;
}
.xuanzewuliao .el-table tbody td .cell {
  padding: 0.1rem 0.1rem !important;
}
.xuanzewuliao .h-formbLine .el-form-item__label{
  width: 39%;
}
.xuanzewuliao  .h-formbLine .el-form-item__content{
  width: 55%;
}
.xuanzewuliao .yxline .h-formbLine .el-form-item__content{
  width: 55%;
}
.xuanzewuliao .yxline{
  padding-top: 0;
}
.xuanzewuliao .h-pagination{
  padding-top: 0rem;
  padding-bottom: 0rem;
}
.xuanzewuliao .h-rowCon{
  padding-bottom: 0rem;
}
</style>
